import Analytics from '@udacity/ureact-analytics';
import webPerf from '@udacity/web-perf-metrics';
import CONFIG from 'configLoader';

Analytics.init(process.env.REACT_APP_SEGMENT_WRITE_KEY);
webPerf.track(CONFIG.siteIdentifier);
